import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

class PhoneStatus extends Component {

    constructor(props) {
        super(props);
        this.renderStatus = this.renderStatus.bind(this);
        this.getStatus = this.getStatus.bind(this);
    }

    renderStatus(data) {

        let text = "hangup";

        if (this.props.agent.strStatus.toLowerCase() === "talking") {
        
            text = "talking";
        
            if (this.props.agent.ringing) {
                text = "ringing";
            }
        
            if (this.props.agent.dialing) {
                text = "dialing";
            }
        
        }

        return (<Tooltip style={{ position: "fixed" }} {...data}>{this.props.t(text)}</Tooltip>);

    }

    getStatus() {
        let content = <FontAwesomeIcon className="px-1 text-muted" size="lg" icon={duotone("phone-hangup")} />

        if (this.props.agent.strStatus.toLowerCase() === "talking") {
            if (this.props.agent.ringing) {
                content = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={duotone("bell-on")} />
            } else {
                if (this.props.agent.incomingCall) {
                    content = <FontAwesomeIcon className="px-1 text-success" size="lg" icon={duotone("phone-arrow-down-left")} />
                } else {
                    if (this.props.agent.dialing) {
                        content = <FontAwesomeIcon className="px-1 text-primary" size="lg" icon={duotone("phone-volume")} />
                    } else {
                        content = <FontAwesomeIcon className="px-1 text-primary" size="lg" icon={duotone("phone-arrow-up-right")} />
                    }
                }
            }
        }
        return content;
    }
    render() {
        return (<OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={this.renderStatus}>
            <div style={{ display: "inline-block" }}>
                {this.getStatus()}
            </div>
        </OverlayTrigger>)
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
    };
};

export default compose(connect(mapStateToProps, null), withTranslation())(PhoneStatus);